// localStorage.js
export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('YouMaster_user@User');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('YouMaster_user@User', serializedState);
  } catch {
    // ignore write errors
  }
};
